import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

export const Modal = ({
  open,
  onClose,
  title,
  children,
  maxWidth = "sm",
  fullWidth = true,
  contentSx,
  transitionDuration,
  closeDisabled = false,
}) => (
  <Dialog
    open={open}
    onClose={closeDisabled ? undefined : onClose}
    fullWidth={fullWidth}
    maxWidth={maxWidth}
    transitionDuration={transitionDuration}
    PaperProps={{
      sx: { position: "relative" },
    }}>
    <DialogTitle sx={{ pr: 7 }}>
      <Typography variant="h6" component="span" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      <IconButton
        aria-label="Close dialog"
        onClick={onClose}
        disabled={closeDisabled}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color: "text.secondary",
        }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={contentSx}>{children}</DialogContent>
  </Dialog>
);

export default Modal;
